import { render, staticRenderFns } from "./Comm.vue?vue&type=template&id=f8c81a44&"
import script from "./Comm.vue?vue&type=script&lang=js&"
export * from "./Comm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports